import CardSummary from './CardSummary';

export default CardSummary;
